import validate from "/usr/src/app/content/n3-packages-04a57f64-417f-42f8-966d-ee87c45f3afd/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-04a57f64-417f-42f8-966d-ee87c45f3afd/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}